import { FormikProps } from 'formik';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { CustomerFormType } from 'types/customer/customerTypes';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useTranslation } from 'react-i18next';

export default function TopLabelCustomerContactSection({
  formik,
}: {
  formik: FormikProps<CustomerFormType>;
}) {
  const { t } = useTranslation();
  const { showAllValidateErrors } = useSelector((s: RootState) => s.Customer);

  // const err = (path: keyof CustomerContact) =>
  //   ((formik.touched.customerContact as any)?.[path] &&
  //     (formik.errors.customerContact as any)?.[path] &&
  //     typeof (formik.errors.customerContact as any)[path] === 'string') ||
  //   (formik.isValid === false &&
  //     (formik.errors.customerContact as any)?.[path] &&
  //     showAllValidateErrors === true);

  return (
    <>
      {/* <div className="mb-3" style={{ fontSize: '16px', fontWeight: '600' }}> */}
      <div className="mb-4 accent-bar">{t('Contact Information')}</div>
      <div className="row">
        <Col sm={12}>
          <FormGroup>
            <Label htmlFor="customerContact.last_name">
              {t('Contact Name')}
            </Label>

            <Input
              type="text"
              className="form-control"
              id="customerContact.last_name"
              name="customerContact.last_name"
              value={formik.values.customerContact.last_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={255}
            />
            {(formik.touched.customerContact?.last_name &&
              formik.errors.customerContact?.last_name &&
              typeof formik.errors.customerContact?.last_name === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.last_name}
              </div>
            ) : null}
          </FormGroup>
        </Col>
      </div>
      <div className="row">
        <Col sm={12}>
          <FormGroup>
            <Label htmlFor="customerContact.phoneNumber">
              {t('Phone Number')}
            </Label>

            <Input
              type="tel"
              className="form-control"
              id="customerContact.phoneNumber"
              name="customerContact.phoneNumber"
              value={formik.values.customerContact.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={20}
            />
            {(formik.touched.customerContact?.phoneNumber &&
              formik.errors.customerContact?.phoneNumber &&
              typeof formik.errors.customerContact?.phoneNumber === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.phoneNumber}
              </div>
            ) : null}
          </FormGroup>
        </Col>
      </div>
      <div className="row">
        <Col sm={12}>
          <FormGroup>
            <Label htmlFor="customerContact.email">{t('Email')}</Label>

            <Input
              type="email"
              className="form-control"
              id="customerContact.email"
              name="customerContact.email"
              value={formik.values.customerContact.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={100}
            />
            {(formik.touched.customerContact?.email &&
              formik.errors.customerContact?.email &&
              typeof formik.errors.customerContact?.email === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.email}
              </div>
            ) : null}
          </FormGroup>
        </Col>
      </div>
      <div className="row">
        <Col sm={12}>
          <FormGroup>
            <Label htmlFor="customerContact.facebook">{t('Facebook')}</Label>

            <Input
              type="text"
              className="form-control"
              id="customerContact.facebook"
              name="customerContact.facebook"
              value={formik.values.customerContact.facebook}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={100}
            />
            {(formik.touched.customerContact?.facebook &&
              formik.errors.customerContact?.facebook &&
              typeof formik.errors.customerContact?.facebook === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.facebook}
              </div>
            ) : null}
          </FormGroup>
        </Col>
      </div>
      <div className="row">
        <Col sm={12}>
          <FormGroup>
            <Label htmlFor="customerContact.line">{t('Line')}</Label>

            <Input
              type="text"
              className="form-control"
              id="customerContact.line"
              name="customerContact.line"
              value={formik.values.customerContact.line}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={100}
            />
            {(formik.touched.customerContact?.line &&
              formik.errors.customerContact?.line &&
              typeof formik.errors.customerContact?.line === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.line}
              </div>
            ) : null}
          </FormGroup>
        </Col>
      </div>
      <div className="row">
        <Col sm={12}>
          <FormGroup>
            <Label htmlFor="customerContact.instagram">{t('Instagram')}</Label>

            <Input
              type="text"
              className="form-control"
              id="customerContact.instagram"
              name="customerContact.instagram"
              value={formik.values.customerContact.instagram}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={100}
            />
            {(formik.touched.customerContact?.instagram &&
              formik.errors.customerContact?.instagram &&
              typeof formik.errors.customerContact?.instagram === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.instagram}
              </div>
            ) : null}
          </FormGroup>
        </Col>
      </div>

      <div className="mb-3 row"></div>
    </>
  );
}
